<div class="custom advanced-setup" *transloco="let t; read: 'advancedAccountSetup'">
  <div class="modal-header advanced-setup__header">
    @if (feature.iconUrl) {
      <img class="advanced-setup__header-image" [src]="feature.iconUrl" [alt]="feature.name" />
    } @else if (feature.icon) {
      <i class="advanced-setup__header-icon {{ feature.icon }}"></i>
    }

    <div class="d-flex flex-column">
      <h5 class="modal-title">{{ feature.name }}</h5>
      <span class="modal-subtitle">{{ t("subtitle") }}</span>
    </div>

    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="modal-body advanced-setup__body">
    @switch (status()) {
      @case (Status.Pending) {
        <div class="advanced-setup__state">
          <div class="advanced-setup__visual">
            <span class="spinner-border advanced-setup__spinner" role="status"></span>
          </div>
          <div>
            <p class="advanced-setup__title">{{ t("pending." + titleKey, { feature: feature.name }) }}</p>
            <p class="advanced-setup__description">{{ t("pending.description") }}</p>
          </div>
        </div>

        <div class="advanced-setup__note">
          <i class="ri-information-line"></i>
          <span>{{ t("pending.note") }}</span>
        </div>
      }

      @case (Status.Error) {
        <div class="advanced-setup__state">
          <div class="advanced-setup__visual advanced-setup__visual--error">
            <i class="ri-error-warning-line"></i>
          </div>
          <div>
            <p class="advanced-setup__title">{{ t("error." + titleKey, { feature: feature.name }) }}</p>
            <p class="advanced-setup__description">{{ t("error.description") }}</p>
          </div>
        </div>

        <button type="button" class="btn btn-primary w-100 advanced-setup__action" [disabled]="retrying()" (click)="retry()">
          @if (retrying()) {
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          }
          {{ t("error.retry") }}
        </button>
      }

      @case (Status.Ready) {
        <div class="advanced-setup__state">
          <div class="advanced-setup__visual advanced-setup__visual--ready">
            <i class="ri-check-line"></i>
          </div>
          <div>
            <p class="advanced-setup__title">{{ t("ready." + titleKey, { feature: feature.name }) }}</p>
            <p class="advanced-setup__description">{{ t("ready.description", { feature: feature.name }) }}</p>
          </div>
        </div>

        <button type="button" class="btn btn-primary w-100 advanced-setup__action" (click)="open()">
          {{ t("ready.open", { feature: feature.name }) }}
        </button>
      }
    }
  </div>
</div>
